import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useStore } from "@/lib/store";
import { Badge } from "@/components/ui/badge";

export function ProductCard({ product, index = 0 }) {
  const { format, addToCart } = useStore();
  const primarySize = product.sizes.find((s) => !/sample/i.test(s.label)) || product.sizes[0];

  const chips = [
    ...(product.notes?.heart || []).slice(0, 2),
    ...(product.notes?.base || []).slice(0, 1),
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.55, delay: 0.04 * index, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`product-card-${product.slug}`}
      className="sd-tilt group bg-[#F1ECE4] border border-black/10 rounded-2xl overflow-hidden flex flex-col"
    >
      <Link to={`/product/${product.slug}`} className="block">
        <div
          className="aspect-[4/5] relative overflow-hidden bg-[#FAF8F5]"
        >
          <div
            className="absolute inset-0 transition-transform duration-500 group-hover:scale-[1.04]"
            style={{
              backgroundImage: `url(${product.image_url})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          />
          <div className="absolute top-3 left-3 flex flex-wrap gap-2">
            <Badge className="bg-[#2C3E35]/10 text-[#2C3E35] border border-[#2C3E35]/25 rounded-full px-2.5 py-0.5 text-[10px] tracking-[0.12em] uppercase">
              Inspired by {product.inspired_by}
            </Badge>
          </div>
          <div className="absolute bottom-3 left-3">
            <Badge className="bg-black/70 text-white/90 border-none rounded-full px-2.5 py-0.5 text-[10px] tracking-[0.14em] uppercase">
              {product.concentration} • {product.concentration_pct}% Oil
            </Badge>
          </div>
        </div>
      </Link>
      <div className="p-3.5 sm:p-5 flex-1 flex flex-col">
        <div className="text-[10px] sm:text-xs uppercase tracking-[0.18em] text-[#1A1918]/60">{product.number}</div>
        <Link to={`/product/${product.slug}`} className="font-serif text-base sm:text-xl mt-0.5 sm:mt-1 hover:text-[#C5A059] transition-colors leading-tight">
          {product.name}
        </Link>
        <p className="text-[11px] sm:text-sm text-[#1A1918]/70 mt-1 line-clamp-1">{product.tagline}</p>
        <div className="mt-2 sm:mt-3 flex flex-wrap gap-1 sm:gap-1.5">
          {chips.map((n) => (
            <span key={n} className="px-2 sm:px-2.5 py-0.5 sm:py-1 text-[10px] sm:text-[11px] rounded-full bg-[#FAF8F5] border border-black/10 text-[#1A1918]/75">
              {n}
            </span>
          ))}
        </div>
        <div className="mt-3 sm:mt-4 flex items-center justify-between">
          <div className="text-[13px] sm:text-[15px] text-[#1A1918]" data-testid={`product-price-${product.slug}`}>
            <span className="font-medium">{format(primarySize.price_usd)}</span>
            <span className="hidden sm:inline text-xs text-[#1A1918]/60 ml-1">/ {primarySize.label}</span>
          </div>
          <button
            data-testid={`quick-add-${product.slug}`}
            onClick={() => addToCart(product.id, primarySize.label, 1)}
            className="text-[10px] sm:text-xs uppercase tracking-[0.14em] sm:tracking-[0.16em] text-[#1A1918] hover:text-[#C5A059] transition-colors"
          >
            Quick Add
          </button>
        </div>
      </div>
    </motion.div>
  );
}

export default ProductCard;
